/* List of projects using the same origin App - Register/Add new project config here */

const config = require('./' + process.env.REACT_APP_PROJECT_NAME + '-production-config');
export default config;
